
const TRIP_PAGE_DATA = window.TRIP_PAGE_DATA ? window.TRIP_PAGE_DATA : {};

const SDK_CONFIG = {
  ...TRIP_PAGE_DATA.weixin_share_config,
  jsApiList: [
    'onMenuShareAppMessage',
    'onMenuShareTimeline',
    'onMenuShareQQ',
    'onMenuShareWeibo',
    'onMenuShareQZone',
    'hideAllNonBaseMenuItem'
  ]
};


/**
 * 微信分享功能
 *
 * @export
 * @param {object} sdkConfig  sdk配置
 * ```js
 * {
 *   appId: '',
 *   timestamp: '',
 *   nonceStr: '',
 *   signature: '',
 *   jsApiList: []
 * }
 * ```
 * @param {any} shareConfig  分享内容配置
 * ```js
 * {
 *   title: '',
 *   content: '',
 *   photo: '',
 *   shareUrl: '',
 *   success: () => {},
 *   cancel: () => {}
 * }
 * ```
 * @returns
 */
export default function share(shareConfig, sdkConfig = SDK_CONFIG) {
  const wx = window.wx;
  // 微信分享
  if (typeof wx !== 'object') {
    return;
  }

  wx.config(sdkConfig);

  // shareConfig = convert(shareConfig, {
  //   content: 'desc',
  //   photo: 'imgUrl',
  //   shareUrl: 'link'
  // });

  shareConfig = {
    title: shareConfig.title,
    desc: shareConfig.content,
    imgUrl: shareConfig.photo,
    link: shareConfig.shareUrl
  };

  console.log('微信分享参数', shareConfig);

  wx.ready(function () {
    wx.onMenuShareTimeline(shareConfig);
    wx.onMenuShareAppMessage(shareConfig);
    wx.onMenuShareQQ(shareConfig);
    wx.onMenuShareWeibo(shareConfig);
    wx.onMenuShareQZone(shareConfig);
  });
}


function convert(obj, map) {
  let result = {...obj};
  let key;
  for (key in map) {
    result[map[key]] = obj[key];
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/components/Share/wechat.js